<template>
    <div>

        <div ref="timer"
             class="modal fade timer-modal"
             role="dialog"
        >
            <div class="modal-dialog modal-md" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Idle Session Warning</h4>
                    </div>
                    <div class="modal-body">
                        <div class=" p-20">
                            Your session is about to expire in {{ warningExpirationDisplay }}.

                            <p><i class="fa fa-exclamation-triangle text-danger"></i>
                                Do you want to continue your session?</p>
                        </div>

                    </div>
                    <div class="modal-footer" style="margin-top:15px;">
                        <button type="button" class="btn btn-lg btn-primary" @click="continueSession"
                                data-dismiss="modal">
                            <i class="fa fa-times"></i> Yes
                        </button>
                        <button type="button" class="btn btn-lg btn-secondary" @click="logoutSession"
                                data-dismiss="modal">
                            <i class="fa fa-check"> </i> Logout
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
  export default {
     props: {},
     data: function() {
        return {
            timer: null,
            nextCheck: 2,
            warningExpiration: 1,
            timeout: null,
            interval: null,
            response: null,
        }
    },
    computed: {
       warningExpirationDisplay: function() {
         if (this.warningExpiration > 1 ) {
            return this.warningExpiration + ' minutes';
         } else {
            return this.warningExpiration + ' minute';
         }
       },
    },
    methods: {
        logoutSession: function() {
            window.location.href = '/logout';
        },
        continueSession: function() {
            this.$http.post('/refresh-session', {}
            )
            .then (function(response) {
                this.resetTimers()
                this.response = response
                this.sessionCheck()
            })
        },

        updateExpiration: function() {
            this.warningExpiration = this.warningExpiration - 1;
            if (this.warningExpiration <= 0 ) {
                this.logoutSession()
            }
        },

        resetTimers: function() {
            clearInterval(this.interval)
            clearTimeout(this.timeout)
        },

        sessionCheck: function () {
            var vm = this;
            this.$http.get('/session-check', {})
            .then(function (response) {
                this.nextCheck = response.data.displayWarningIn
                this.warningExpiration = response.data.displayExpiration
                var timeoutVal = 1000 * 60 * this.nextCheck;
                this.timeout = setTimeout(function() {
                    vm.showTimer();
                }, timeoutVal)
            })
        },
        showTimer: function() {
            //update expiration every minute (1000 milliseconds * 60)
            var vm = this;
            this.interval = setInterval(function() {
                vm.updateExpiration();
            }, 60000);
            clearTimeout(this.timeout);
            this.timer.modal('show');
        },

    },

    mounted: function() {
        var vm = this;
        vm.timer = $(vm.$refs.timer);
        vm.timer.on('hidden.bs.modal', function() { vm.$emit('closed') });
        $('body').append(vm.timer);
        this.sessionCheck();

    }
 }





</script>



// WEBPACK FOOTER //
// timeout-warning.vue?69f12d70